import moment, { Moment } from "moment";

export interface TicketDto {
  code: string;
  isTardy: boolean;
  tardySequenceNumber: number | null;
  checkInAt: string | null;
  checkInBy: string | null;
}

export class Ticket {
  code: string;
  isTardy: boolean;
  tardySequenceNumber: number | null;
  checkInAt: Moment | null;
  checkInBy: string | null;

  constructor(dto: TicketDto) {
    this.code = dto.code;
    this.isTardy = dto.isTardy;
    this.tardySequenceNumber = dto.tardySequenceNumber;
    this.checkInAt = dto.checkInAt ? moment(dto.checkInAt) : null;
    this.checkInBy = dto.checkInBy;
  }
}
